import { useEffect } from 'react';
import { type GeolocationInfo } from '@cx-web/api-clients/geoip-api/types';

import { type Repub } from '@cx-modules/constants';

export const GoogleTagManagerHead = ({
  geolocationInfo,
  gtmId,
  repub,
  shouldRender,
  shouldRenderPostHydration,
  userGroup = '',
  userId = '',
}: {
  geolocationInfo: GeolocationInfo;
  gtmId: string;
  repub: Repub;
  shouldRender: boolean;
  shouldRenderPostHydration: boolean;
  userGroup: string | undefined;
  userId: string | undefined;
}) => {
  useEffect(() => {
    if (!shouldRender || !shouldRenderPostHydration) {
      return;
    }

    const gtmScript = document.createElement('script');
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    gtmScript.async = true;
    document.head.appendChild(gtmScript);
  }, [gtmId, shouldRender, shouldRenderPostHydration]);

  const { countryCode, geoCity, geoCountry, geoRegion, subdivisionCode } = geolocationInfo;

  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							country: '${countryCode}',
							countryCode: '${countryCode}',
							repub: '${repub}',
							state: '${subdivisionCode ?? ''}',
							geoCity: '${geoCity}',
							geoRegion: '${geoRegion}',
							geoCountry: '${geoCountry}',
							userId: '${userId}',
							userGroup: '${userGroup}',
						});
						window.dataLayer.push({
							'gtm.start': new Date().getTime(),
							event: 'gtm.js'
						});
					`,
        }}
        id="gtag-init"
      />
      {shouldRender && !shouldRenderPostHydration && (
        <script async={true} src={`https://www.googletagmanager.com/gtm.js?id=${gtmId}`} />
      )}
    </>
  );
};
